import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "../context/ContentContext";
import { mediaUrl } from "../lib/api";
import { external } from "../lib/links";

export const ConsultBand = () => {
  const { content } = useContent();
  const c = content.consult;
  const links = content.links;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="consult-band" className="relative py-28 md:py-36 overflow-hidden">
      <motion.div style={{ y, scale: 1.12 }} className="absolute inset-0 z-0">
        <img src={mediaUrl(c.image)} alt="The peaceful shoreline of Boundary Bay" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 z-0" style={{ background: "linear-gradient(120deg, rgba(28,43,51,0.9) 0%, rgba(40,58,60,0.78) 45%, rgba(74,94,88,0.62) 100%)" }} />

      <div className="relative z-10 mx-auto max-w-6xl px-5 md:px-8">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
          <div className="max-w-2xl">
            <Reveal delay={0.05}>
              <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">{c.heading}</h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg text-white/85 leading-relaxed max-w-xl">{c.body}</p>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <a data-testid="consult-band-btn" href={links.janeConsult} {...external} className="group inline-flex items-center gap-2 rounded-full bg-cream text-ink px-9 py-5 text-lg font-semibold transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-2xl whitespace-nowrap">
              {c.cta}
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ConsultBand;
